import * as Yup from 'yup';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';

const T = Translator.create();
const _logger = Log.create('Reports Page');
const RegExpBirthDate = /^([0-2][0-9]|(3)[0-1])(.)(((0)[0-9])|((1)[0-2]))(.)\d{4}$/;

export function getValidation() {

return Yup.object()
    .shape({
        selectedCourses: Yup.string(),
        selectedClasses: Yup.string(),
        selectedUsers: Yup.string(),
        selectedActivityTypes: Yup.string(),
        selectedActivities: Yup.string(),
        selectedStatuses: Yup.string(),
        dateRange: Yup.string()
    })
    .test(
        'oneOfRequired',
        T.t('r_validation_report_one_of_required'),
        // tslint:disable-next-line: only-arrow-functions
        function(item: any) {
            return (item.selectedCourses || item.selectedClasses || item.selectedUsers || item.selectedActivityTypes || item.selectedActivities || item.selectedStatuses || item.dateRange);
        }
    );
}

